export const environment = {
	production: true,

	APP_ENV: 'master',
	COMMIT_HASH: '82cb5fb081a5447380e835fb93eb9b537567b9e4',
	API_URL: '/api/',
	SERVICE_SENTRY_DSN_PUBLIC: 'https://5ad80b7a4b734312baade3f0d7621365@sentry.io/221572',
};
